module.exports = __webpack_public_path__ + "img/work-team.5b0ffcd8.png";